import axios from "axios";
import { serviceBaseUrl } from "./constants";
import { uploadFile } from "./fileUploadService";

export const getUserNotifications = async () => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/userNotifications`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (userNotification: any) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/markAsRead/${userNotification.id}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating user:`, error);
    throw error;
  }
};

export const registerForSeason = async (userDetails: any) => {
  try {
    if (userDetails.handicapCertificate) {
      const res = await uploadFile(userDetails.handicapCertificate);
      if (res.code !== 999) {
        userDetails.handicapCertificate = res.result;
      } else {
        return res;
      }
    }

    if (userDetails.teamLogo) {
      const res = await uploadFile(userDetails.teamLogo);
      if (res.code !== 999) {
        userDetails.teamLogo = res.result;
      } else {
        return res;
      }
    }

    const response = await axios.post(
      `${serviceBaseUrl}/registerForSeason`,
      userDetails
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating user:`, error);
    throw error;
  }
};

export const getUserRegistration = async (
  seasonId: string,
  userEmail: string
) => {
  try {
    const response = await axios.get(
      `${serviceBaseUrl}/registeredPlayer/${seasonId}/${userEmail}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user registration:", error);
    throw error;
  }
};

export const getMyInvitations = async (seasonId: string) => {
  try {
    const response = await axios.get(
      `${serviceBaseUrl}/getMyInvitations/${seasonId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching invitations:", error);
    throw error;
  }
};

export const acceptInvitation = async (invitationId: string) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/acceptInvite/${invitationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error accepting invitation:", error);
    throw error;
  }
};

export const rejectInvitation = async (invitationId: string) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/rejectInvite/${invitationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error rejecting invitation:", error);
    throw error;
  }
};


export const updateRegistration = async (userDetails: any) => {
  try {
    if (userDetails.handicapCertificate && userDetails.handicapCertificate instanceof File) {
      const res = await uploadFile(userDetails.handicapCertificate);
      if (res.code !== 999) {
        userDetails.handicapCertificate = res.result;
      } else {
        return res;
      }
    }

    if (userDetails.teamLogo && userDetails.teamLogo instanceof File) {
      const res = await uploadFile(userDetails.teamLogo);
      if (res.code !== 999) {
        userDetails.teamLogo = res.result;
      } else {
        return res;
      }
    }

    console.log("userDetails", userDetails);
    const response = await axios.post(
      `${serviceBaseUrl}/updatePlayer`,
      userDetails
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating user:`, error);
    throw error;
  }
};
